import Browser from './browser.js';
import configManager from '../config/configManager';

class Pay {
  constructor() {
    // 通过配置管理器获取支付类型配置
    this.type = {
      ALIPAY_WAP: configManager.get('ALIPAY_WAP'),
      ALIPAY_APP: configManager.get('ALIPAY_APP'),
      ALIPAY_JS: configManager.get('ALIPAY_JS'),
      WECHATPAY_WAP: configManager.get('WECHATPAY_WAP'),
      WECHATPAY_APP: configManager.get('WECHATPAY_APP'),
      WECHATPAY_JS_PUBLIC: configManager.get('WECHATPAY_JS_PUBLIC'),
      WECHATPAY_JS_PROGRAM: configManager.get('WECHATPAY_JS_PROGRAM')
    };
  }

  getPayType() {
    let type = '';
    // #ifdef APP-PLUS
    type = this.type.WECHATPAY_APP;
    // #endif
    // #ifdef H5
    let browser = new Browser();
    if (browser.browser == 'Wechat') {
      type = this.type.WECHATPAY_JS_PUBLIC;
    } else {
      type = this.type.WECHATPAY_WAP;
    }
    // #endif
    // #ifdef MP-WEIXIN
    type = this.type.WECHATPAY_JS_PROGRAM;
    // #endif
    // #ifdef MP-ALIPAY
    type = this.type.ALIPAY_WAP;
    // #endif
    return type;
  }

  /**
   * 唤醒支付
   * @param {Object} type
   * @param {Object} options
   */
  requestPayment(type, options) {
    return new Promise((reslove, reject) => {
      let payOptions = {};
      payOptions.provider = type;
      switch (type) {
        case 'wxpay':
          payOptions = Object.assign(payOptions, options.orderInfo);
          // #ifdef H5
          this.wxjspay(options.orderInfo)
            .then((res) => {
              reslove(res);
            })
            .catch((e) => {
              reject(e);
            });
          // #endif
          break;
        case 'alipay':
          payOptions.orderInfo = JSON.stringify(...options.orderInfo);
          break;
        default:
          break;
      }

      // #ifndef H5
      uni.requestPayment({
        ...payOptions,
        success(res) {
          reslove(res);
        },
        fail(e) {
          reject(e);
        }
      });
      // #endif
    });
  }

  /**
   * H5微信支付
   * @param {Object} orderInfo
   */
  wxjspay(orderInfo) {
    return new Promise((resolve, reject) => {
      if (typeof WeixinJSBridge == 'undefined') {
        reject({
          err_code: -1,
          err_desc: '只允许微信里使用',
          err_msg: 'WeixinJSBridge:undefined'
        });
      } else {
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest',
          { ...orderInfo },
          (res) => {
            if (res.err_msg == 'get_brand_wcpay_request:ok') {
              resolve(res);
            } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
              resolve(res);
            } else {
              //alert(res.err_code + res.err_desc + res.err_msg);
              reject(res);
            }
          }
        );
      }
    });
  }
}

export default new Pay();
